import { Icon } from 'ant-design-vue'
import iconfontUrl from '@/assets/icons/iconfont'
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: iconfontUrl
});

export default IconFont